/** Presentation helpers shared across both dashboards. */

const DATE_OPTS: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short', year: 'numeric' };

export function formatDate(value?: string | null): string {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleDateString('en-GB', DATE_OPTS);
}

export function formatDateTime(value?: string | null): string {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return `${date.toLocaleDateString('en-GB', DATE_OPTS)}, ${date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
    })}`;
}

/** Compact axis/short label — `4 Aug`. */
export function formatShortDate(value: string): string {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

export function formatNumber(value: number): string {
    return new Intl.NumberFormat('en-GB').format(value);
}

export function formatPercent(value: number): string {
    return `${value.toFixed(value % 1 === 0 ? 0 : 1)}%`;
}

/** `PENDING_REVIEW` → `Pending review` */
export function humanizeStatus(status: string): string {
    const lower = status.toLowerCase().replace(/_/g, ' ');
    return lower.charAt(0).toUpperCase() + lower.slice(1);
}

/** `ambassador.code_changed` → `Code changed` */
export function humanizeAction(action: string): string {
    const tail = action.includes('.') ? action.split('.').slice(1).join('.') : action;
    const spaced = tail.replace(/_/g, ' ');
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
